import React, {FC, ReactNode} from 'react';

import {GENERAL} from '@optimaxdev/analytics/desktop/constants/events/general';
import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {InView} from 'react-intersection-observer';

import {flags} from 'libs/rollout';

import {spawnPriorityTask} from 'libs/timers/spawnPriorityTask/spawnPriorityTask';

import {getBadgeProps, getIsCtpBadgeRedesign} from './getters';
import {Badge} from './ui/badge';
import {getIsBadgeIdValid} from './validations';

const sendAnalytics = () => {
    sendDesktopAnalyticsPerSession({
        event: {
            ...GENERAL.EXPERIMENT_INDICATION,
            action: 'dCTPbadgesRedesign',
        },
        isInteraction: false,
        label: String(flags.dCTPbadgesRedesign.getValue()),
    });
};

type PropsType = {
    children: ReactNode;
    id: number | string;
};

/** BadgeRedesign */
export const BadgeRedesign: FC<PropsType> = ({children, id}) => {
    const isRedesign = getIsCtpBadgeRedesign();
    const isIdValid = getIsBadgeIdValid(id);

    const onBadgeView = (inView: boolean) => {
        if (!inView || !isIdValid) return;
        spawnPriorityTask(sendAnalytics);
    };

    if (isRedesign && isIdValid) {
        const badgeProps = getBadgeProps(id);
        return (
            <InView onChange={onBadgeView} triggerOnce>
                <Badge {...badgeProps} id={id as number} />
            </InView>
        );
    }

    return (
        <InView onChange={onBadgeView} triggerOnce>
            {children}
        </InView>
    );
};
